import React from "react";
import { useNavigate } from "react-router-dom";

export default function FooterPrivacy() {
  const navigate = useNavigate();
  return (
    <div className="popup-message-overlay">
      <div className="main-footer-modal">
        <div className="main-footer-modal-content">
          <h1>Privacy Policy for Harong Bikolnon Creatives</h1>
          <p className="italic">Last updated: August 1, 2025</p>
          <ol className="text-left">
            <InformationOverview />
            <InformationPurpose />
            <GoogleData />
            <DataDeletion />
            <InformationSharing />
            <DataSecurity />
            <YourChoices />
            <AccessAndCorrection />
            <PrivacyPolicyChanges />
            <ContactUs />
          </ol>
        </div>
        <div
          className="main-form-footer"
          style={{ borderRadius: "0 0 20px 20px" }}
        >
          <button
            type="submit"
            className="main-form-footer-button"
            style={{ width: "20%" }}
            onClick={() => navigate(-1)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function InformationOverview() {
  return (
    <li className="">
      <span className="font-semibold">Data That We Gather</span>
      <ol className="pl-4">
        <li>
          <span className="font-semibold">Personalized Data</span>
          <p>
            When you use our website or services, we might get personal
            information about you.
          </p>
          <ul className="pl-4" type="">
            <li>Name</li>
            <li>Electronic Mail Address</li>
            <li>Phone Number</li>
            <li>Address</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold">Booking Details</span>
          <p>
            When you book tickets for our theatrical performances, we might also
            gather the following additional data:
          </p>
          <ul className="pl-4">
            <li>Date and time of the show</li>
            <li>Venue details</li>
            <li>Type of performance or event</li>
          </ul>
        </li>
        <li>
          <span className="font-semibold">Newsletter Enrollment</span>
          <p>
            We will gather your email address if you decide to sign up for our
            newsletter so we can bring you news, offers, and other pertinent
            information.
          </p>
        </li>
      </ol>
    </li>
  );
}

function InformationPurpose() {
  return (
    <li>
      <span className="font-semibold">How your information is used by us</span>
      <ol className="pl-4">
        <li>
          <span className="font-semibold">Booking of Services</span>
          <p>
            We use your personal information to make it easier for you to book
            tickets for our theatrical performances and to communicate with us
            regarding the details of the show or event.
          </p>
        </li>
        <li>
          <span className="font-semibold">Newsletter</span>
          <p>
            In the event that you sign up for our newsletter, we will use your
            email address to send you news, offers, and other information about
            Harong Bikolnon Creatives.
          </p>
        </li>
        <li>
          <span className="font-semibold">
            Sharing and Disclosure of Information
          </span>
          <p>
            We do not sell, trade, or otherwise disclose your personal
            information to unaffiliated third parties except as described in
            this Privacy Policy. We may share your information in the following
            circumstances:
          </p>
          <ol className="pl-4">
            <li>
              {" "}
              <span className="font-semibold">With Service Providers</span>
              <p>
                We may share your information with trusted service providers who
                assist us in operating our website, conducting our business, or
                providing our services, so long as those parties agree to keep
                this information confidential and use it only for the purposes
                for which it was provided.
              </p>
            </li>
            <li>
              {" "}
              <span className="font-semibold">For Legal Reasons</span>
              <p>
                We may share your information when required to do so by law, or
                when we believe that disclosure is necessary to protect our
                rights, comply with a judicial proceeding, court order, or legal
                process served on us
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </li>
  );
}

function GoogleData() {
  return (
    <li>
      <span className="font-semibold">Use of Google User Data</span>
      <p>
        We may access certain Google user data to provide or improve our
        application&apos;s functionality. This data will only be used for the
        purpose of delivering our services and enhancing your experience with
        our application. We do not use Google user data for any other purposes
        unless explicitly disclosed and agreed upon by the user.
      </p>
    </li>
  );
}
function DataDeletion() {
  return (
    <li>
      <span className="font-semibold">Data Retention and Deletion</span>
      <p>
        We retain your personal data only for as long as necessary to fulfill
        the purposes for which it was collected, including the provision of
        services and compliance with legal obligations. Google user data is
        retained for the period necessary to support the functionality of our
        services and is deleted once it is no longer required. If you wish to
        request the deletion of your data, please contact us at the information
        provided below.
      </p>
    </li>
  );
}
function InformationSharing() {
  return (
    <li>
      <span className="font-semibold">Information Exchange</span>
      <p>
        Except as specified in this Privacy Policy, we never trade, sell, or
        otherwise disclose your personal information to unaffiliated third
        parties without your permission.
      </p>
    </li>
  );
}

function DataSecurity() {
  return (
    <li>
      <span className="font-semibold">Information Security</span>
      <p>
        We safeguard your personal information by putting in place appropriate
        security measures. Please note, however, that no electronic storage
        mechanism or transmission over the internet is 100% secure.
      </p>
    </li>
  );
}

function YourChoices() {
  return (
    <li>
      <span className="font-semibold">Your Decisions</span>
      <p>
        You have the option to withhold some information, but doing so might
        make it more difficult for you to utilize our services or access some
        features.
      </p>
    </li>
  );
}

function AccessAndCorrection() {
  return (
    <li>
      <span className="font-semibold">Access and Error</span>
      <p>
        You are entitled to see and update your personal data. Please call us at
        +639672737242/+639457936100 if you would like to review or change your
        information.
      </p>
    </li>
  );
}

function PrivacyPolicyChanges() {
  return (
    <li>
      <span className="font-semibold">
        Modifications to this Privacy Statement
      </span>
      <p>
        We might occasionally alter our privacy statement. Any modifications
        will take effect as soon as the updated policy is posted on this
        website.
      </p>
    </li>
  );
}

function ContactUs() {
  return (
    <li>
      <span className="font-semibold">Reach Out to Us</span>
      <p>
        For any inquiries or worries regarding our privacy statement, kindly
        reach out to us at +639672737242/+639457936100.
      </p>
    </li>
  );
}
